import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const stats = [
    {
      value: "500+",
      label: "Institutes",
      icon: "Building2"
    },
    {
      value: "20K+",
      label: "Students",
      icon: "Users"
    },
    {
      value: "50K+",
      label: "Interactions",
      icon: "MessageSquare"
    },
    {
      value: "99.9%",
      label: "Uptime",
      icon: "TrendingUp"
    }
  ];

  return (
    <div className="bg-primary/5 rounded-lg p-6 md:p-8 border border-primary/10">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Award" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Trusted by Leading Institutes
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {stats?.map((stat, index) => (
          <div key={index} className="text-center">
            <div className="flex justify-center mb-2">
              <Icon name={stat?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="text-2xl md:text-3xl font-heading font-bold text-primary mb-1 data-text">
              {stat?.value}
            </div>
            <div className="text-xs md:text-sm text-muted-foreground">
              {stat?.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustIndicators;